(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.JSKSignupPrices = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const BASES = new Set(['indicative', 'confirmed']);
  const UNITS = new Set(['piece', 'pair', 'set']);

  function validRecord(record) {
    return Boolean(record) &&
      typeof record.productId === 'string' && record.productId.trim() === record.productId && record.productId.length > 0 &&
      Number.isSafeInteger(record.amountMinor) && record.amountMinor > 0 &&
      record.currency === 'USD' && BASES.has(record.basis) && UNITS.has(record.unit) &&
      !Object.prototype.hasOwnProperty.call(record, 'supplierCost');
  }

  function buildRecords(records) {
    if (!Array.isArray(records)) throw new TypeError('Price records must be an array');
    const map = new Map();
    records.forEach(function (record) {
      if (!validRecord(record)) throw new TypeError('Invalid signup price record');
      if (map.has(record.productId)) throw new Error('Duplicate signup price productId: ' + record.productId);
      map.set(record.productId, Object.freeze({
        productId: record.productId,
        amountMinor: record.amountMinor,
        currency: record.currency,
        basis: record.basis,
        unit: record.unit
      }));
    });
    return map;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function formatAmount(record) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: record.currency, currencyDisplay: 'code',
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(record.amountMinor / 100).replace(/\s+/g, ' ');
  }

  function render(records, context) {
    if (!(records instanceof Map) || !context || context.interestOnly !== true || typeof context.productId !== 'string') return '';
    const record = records.get(context.productId);
    if (!record || record.basis !== 'confirmed' || record.productId !== context.productId || !validRecord(record)) return '';
    const label = 'Price';
    const disclaimer = '';
    return '<p class="jsk-signup-price" data-jsk-signup-price role="status" aria-label="' +
      escapeHtml(label + ': ' + formatAmount(record) + ' per ' + record.unit + '. No payment is collected today.') + '">' +
      '<span class="jsk-signup-price__label">' + escapeHtml(label) + ':</span> ' +
      '<span class="jsk-signup-price__amount">' + escapeHtml(formatAmount(record)) + '</span> ' +
      '<span class="jsk-signup-price__unit">per ' + escapeHtml(record.unit) + '</span>. ' +
      '<span class="jsk-signup-price__guard">No payment is collected today.</span>' + disclaimer + '</p>';
  }

  return Object.freeze({ buildRecords: buildRecords, render: render });
});
